// @flow
import React from 'react';
// styles
import './PageTitleWithGoBack.css';
// Components
import GoBackButton from './GoBackButton';

type Props = {
  title: string,
};

const PageTitleWithGoBack = ({ title }: Props) => {
  return (
    <div className="page-title-with-go-back-wrapper">
      <GoBackButton />
      <h1 className="page-title-with-go-back-title">{title}</h1>
    </div>
  );
};

export default PageTitleWithGoBack;
